class WebSafeError extends Error {
  constructor(error) {
    const parseError = (error, key = '') => {
      if (error === null || error === undefined || error === '') {
        return [];
      }
      if (Array.isArray(error)) {
        return error.map((e) => parseError(e, key));
      }
      if (typeof error === 'object') {
        return Object.keys(error).map((k) =>
          parseError(error[k], `${key}${k} - `)
        );
      }
      return [`${key}${error}`];
    };
    const flatten = (errors) => {
      return errors.reduce((flattened, error) => {
        return flattened.concat(Array.isArray(error) ? flatten(error) : error);
      }, []);
    };
    const toArray = () => {
      return flatten(parseError(error));
    };
    const stringify = () => {
      return toArray().reduce(
        (stringified, str, index) =>
          `${stringified}${str}${index === 0 ? '' : '\n'}`,
        ''
      );
    };

    const errorString = stringify();
    super(errorString);
    this.stringify = stringify;
    this.toArray = toArray;

    this.name = 'WebSafeError';
    this.error = error;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(errorString).stack;
    }
  }
  toJSON() {
    return {
      raw: this.error,
      safe: this.toArray(),
    };
  }
}

WebSafeError.isWebSafe = (err) => {
  return err instanceof WebSafeError;
};

export default WebSafeError;
